import { ContentCard } from "@/components/layout/ContentCard.tsx";
import { EmptyState as UntitledEmptyState } from "@/components/_untitled/application/empty-state/empty-state.tsx";
import { prefixes, useTypedTranslation } from "@/locales";
import type { ReactNode } from "react";

export interface EmptyStateProps {
    title?: string;
    description?: string;
    context?: "catalogs" | "items" | "emailTemplates" | "emailLogs" | "bids";
    actions?: ReactNode;
    className?: string;
}

const getIllustrationType = (context: EmptyStateProps['context']) => {
    switch (context) {
        case 'items':
            return 'documents';
        case 'emailTemplates':
        case 'emailLogs':
            return 'documents';
        case 'bids':
            return 'search';
        default:
            return 'box';
    }
};

export const EmptyState = ({ title, description, context = "items", actions, className }: EmptyStateProps) => {
    const [tEmptyState] = useTypedTranslation(prefixes('emptyState'));
    return <ContentCard className={ `bg-gray-25 my-6 p-15 ${ className }` }>
        <UntitledEmptyState size="lg">
            <UntitledEmptyState.Header pattern="circle" patternSize="lg">
                <UntitledEmptyState.Illustration type={ getIllustrationType(context) }/>
            </UntitledEmptyState.Header>

            <UntitledEmptyState.Content>
                <UntitledEmptyState.Title>{ title || tEmptyState(`${ context }.title`) }</UntitledEmptyState.Title>
                <UntitledEmptyState.Description className="whitespace-pre-line">
                    { description || tEmptyState(`${ context }.description`) }
                </UntitledEmptyState.Description>
                { actions && (
                    <div className="flex gap-4 mt-6">
                        { actions }
                    </div>
                ) }
            </UntitledEmptyState.Content>
        </UntitledEmptyState>
    </ContentCard>
}